var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenceCertificates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5H28",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5L12 18.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.5L28 18.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.5L17 18.5",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.5L23 18.5",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5H28",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5H28",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5H28",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5H28",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5L12 30.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18L28 23.3",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5L17 30.5",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.5L23 22.5",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5H20.7",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30.5H21.7",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.5H20",
    stroke: "#F4F4F9",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0468 38H7.95319C6.87614 38 6 37.1451 6 36.0942V3.90588C6 2.85492 6.87614 2 7.95319 2H32.0468C33.1239 2 34 2.85492 34 3.90588V36.0942C34 37.1451 33.1239 38 32.0468 38ZM7.95319 2.70012C7.27156 2.70012 6.7175 3.24076 6.7175 3.90588V36.0942C6.7175 36.7593 7.27156 37.2999 7.95319 37.2999H32.0468C32.7285 37.2999 33.2825 36.7593 33.2825 36.0942V3.90588C33.2825 3.24076 32.7285 2.70012 32.0468 2.70012H7.95319Z",
    fill: "#F4F4F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.74 31.4799C27.3578 31.4799 29.4799 29.3578 29.4799 26.74C29.4799 24.1222 27.3578 22 24.74 22C22.1222 22 20 24.1222 20 26.74C20 29.3578 22.1222 31.4799 24.74 31.4799Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5956 26.7399L24.1756 28.3199L27.1098 25.3856",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5956 31.2542L21.6927 34.6398L24.7399 32.947L27.787 34.6398L26.8841 31.2542",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceCertificates);
export default __webpack_public_path__ + "static/media/LicenceCertificates.30e176c1b9df5c984236ca633cca911d.svg";
export { ForwardRef as ReactComponent };